import {positionStammtischContents} from "./positionStammtischContents.js";
import {checkIfAlreadyProsted} from "../../prost/checkIfAlreadyProsted.js";
import {checkIfAlreadyFavourites} from "../../favourites/checkIfAlreadyFavourites";
import {checkIfAlreadyCollected} from "../../points/checkIfAlreadyCollected";

export function loadStammtischContent(ids, furtherParams, shopUserId, lazyLoadOnThisPage) {
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=load_stammtisch_entries",
        datatype: "json",
        data: {
            "ajax_call_ids": ids,
            "ajax_call_further_params": furtherParams,
            "ajax_call_list_community_type": communityType
        },
        success: function (output) {
            positionStammtischContents(output, lazyLoadOnThisPage);
            checkIfAlreadyProsted(ids, "", shopUserId, false, 1);
            checkIfAlreadyFavourites(ids, shopUserId, 1);
            checkIfAlreadyCollected(ids, shopUserId);
        }
    });
}